export const getForms = ({
  editorStateSelectors
}) => {
  const {
    selectAllFormsInsideLayoutSection
  } = editorStateSelectors;
  return selectAllFormsInsideLayoutSection();
};